module.exports = __webpack_public_path__ + "img/tree-white.e2a99c6d.svg";